/* eslint-disable no-unused-vars */
import Form from "react-bootstrap/Form";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { RotatingLines } from "react-loader-spinner"; // Import the spinner
import "./Login.css";
import { hitApi } from "./utils/apiCall";
import { useAuth } from "./context/AuthContext";
import api from "./utils/Api";

const Login = () => {
  const [mobileNumber, setMobileNumber] = useState(""); // Input field for mobile number
  const [otp, setOtp] = useState("");
  const [otpReceived, setOtpReceived] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [receivedOtp, setReceivedOtp] = useState(""); // Store OTP received from API
  const [username, setUsername] = useState(""); // Store username received from API
  const [authToken, setAuthToken] = useState(""); // Store authToken received from OTP verification
  const navigate = useNavigate(); // Hook to navigate to home page
  const { setIsLoggedIn } = useAuth(); // ✅ Use context to update auth status

  const [showOtpText, setShowOtpText] = useState(false);

  const [passwordRequired, setPasswordRequired] = useState(false);
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (receivedOtp) {
      setShowOtpText(true);
      const timer = setTimeout(() => setShowOtpText(false), 10000); // Hide after 10s
      return () => clearTimeout(timer);
    }
  }, [receivedOtp]);


  // Handle mobile number input change
  const handleMobileNumberChange = (e) => {
    setMobileNumber(e.target.value);
  };

  // Handle OTP input change
  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  async function handleGetOtp(e) {
    e.preventDefault();
    setLoading(true);
    setOtpError("");

    const fd = new FormData();
    fd.append("username", mobileNumber);
    fd.append("programType", "verifyAndSendOTP");
    fd.append("authToken", localStorage.getItem("authToken") || "");
    fd.append("session", localStorage.getItem("session") || "");

    const res = await api.post("/auth/loginCurl", fd);
    console.log(res);

    setLoading(false);

    if (res.data.success) {

      // ✅ CASE 1: PASSWORD REQUIRED
      if (res.data.type === "password_required") {
        setPasswordRequired(true);
        setOtpReceived(false);
        setReceivedOtp("");
        setOtp("");
        setUsername(res.data.data.username);
        toast.success(res.data.message);
        return;
      }

      // ✅ CASE 2: OTP FLOW
      localStorage.setItem("user-phno", mobileNumber);
      setOtpReceived(true);
      setPasswordRequired(false);

      setReceivedOtp(res.data.data.otp);
      setUsername(res.data.data.username);

      toast.success(res.data.message);

    } else {
      toast.error(res.data.message);
    }
  }


  async function handleVerifyOtp(e) {
    e.preventDefault();
    setLoading(true);
    setOtpError("");
    const fd = new FormData();
    fd.append("username", username);
    fd.append("otp", otp);
    fd.append("playerId", "");

    fd.append("programType", "verifyOtp");
    fd.append("authToken", localStorage.getItem("authToken") || "");
    fd.append("session", localStorage.getItem("session") || "");
    const res = await api.post("/auth/loginCurl", fd);
    console.log(res)
    setLoading(false);
    // console.log(res);
    if (res.data.success) {
      localStorage.setItem("user-name", res.data.name);
      localStorage.setItem("currentSession", res.data.currentSession);
      localStorage.setItem("sessionId", res.data.sessionId);
      localStorage.setItem("branch_id", res.data.branch_id);
      localStorage.setItem("currentBranchName", res.data.currentBranchName);
      localStorage.setItem("staffId", res.data.staff_id);
      await callGetTokenApi(res.data.authToken);
      toast.success(res.data.message);
    } else {
      toast.error(res.data.message);
    }
  }


  async function handlePasswordLogin(e) {
    e.preventDefault();
    setLoading(true);
    setOtpError("");

    if (!password.trim()) {
      toast.error("Please enter password");
      setLoading(false);
      return;
    }

    const fd = new FormData();
    fd.append("username", username);
    fd.append("password", password);

          fd.append("programType", "loginWithPassword");
  fd.append("authToken", localStorage.getItem("authToken") || "");
  fd.append("session", localStorage.getItem("session") || "");

    const res = await api.post("/auth/loginCurl",  fd);
    console.log(res)

    setLoading(false);

    if (res.data.success) {
      localStorage.setItem("user-name", res.data.name);
      localStorage.setItem("currentSession", res.data.currentSession);
      localStorage.setItem("sessionId", res.data.sessionId);
      localStorage.setItem("branch_id", res.data.branch_id);
      localStorage.setItem("currentBranchName", res.data.currentBranchName);
      localStorage.setItem("staffId", res.data.staff_id);
      await callGetTokenApi(res.data.authToken);
      toast.success(res.data.message);
    } else {
      toast.error(res.data.message || "Invalid password");
    }
  }

  // const callGetTokenApi = async (authToken) => {
  //   setLoading(true);
  //   try {
  //     const fd = new FormData();
  //     fd.append("authToken", authToken); // Send the authToken
  //     fd.append("programType", "getToken"); // Specify program type to get token

  //     // const response = await fetch(
  //     //   "https://api.sarvajna.co.in/owner/token/tokenCurl",

  //     //   {
  //     //     method: "POST",
  //     //     body: fd,
  //     //   }
  //     // );

  //     // const data = await response.json();

  //     const res = await hitApi("/token/tokenCurl", "getToken", fd);

  //     if (res.success) {
  //       localStorage.setItem("authToken", authToken);
  //       localStorage.setItem("token", res.data); // Assuming the token is in data.data
  //       localStorage.getItem("token") && navigate("/home"); // Change to your actual home route
  //     } else {
  //       toast.error("Failed to get token.");
  //     }
  //   } catch (error) {
  //     toast.error("Failed to get token.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const callGetTokenApi = async (authToken) => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("authToken", authToken);
      fd.append("programType", "getToken");

      const res = await hitApi("/token/tokenCurl", "getToken", fd);

      if (res.success) {
        localStorage.setItem("authToken", authToken);
        localStorage.setItem("token", res.data);

        setIsLoggedIn(true); // ✅ Tell context you're now logged in
        navigate("/home"); // ✅ Navigate to home after login
      } else {
        toast.error("Failed to get token.");
      }
    } catch (error) {
      toast.error("Failed to get token.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Toaster position="top-center" /> {/* Add Toaster here */}
      <div className="login-wrapper d-flex" style={{ paddingTop: "90px" }}>
        <div className="container">
          <div className="text-center px-4">
            <img
              className="login-intro-img"
              src="assets/img/bg-img/Untitled (Logo).png"
              alt="Login Illustration"
              width={"200px"}
            />
          </div>

          <div className="register-form mt-4">
            <form
              onSubmit={
                passwordRequired
                  ? handlePasswordLogin
                  : otpReceived
                    ? handleVerifyOtp
                    : handleGetOtp
              }
            >
              <div className="form-group">
                <input
                  className="form-control large-input"
                  type="text"
                  id="mobileNumber"
                  placeholder="Mobile Number"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  disabled={loading}
                />
              </div>
              {passwordRequired && (
                <div className="form-group mt-3">
                  <input
                    className="form-control large-input"
                    type="password"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading}
                  />
                </div>
              )}

              {otpReceived && (
                <div className="otp-display mt-3">
                  <p>Your OTP: {receivedOtp}</p>
                </div>
              )}




              {/* {otpReceived && (
                <div className="form-group mt-3">
                  <input
                    className="form-control large-input"
                    type="text"
                    id="otp"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={handleOtpChange}
                  />
                </div>
              )} */}

              {otpReceived && showOtpText && (
                <div className="text-center mt-3" style={{ fontSize: "14px", color: "#198754" }}>
                  Your OTP is <strong>{receivedOtp}</strong>
                </div>
              )}


              {otpReceived && (
                <div className="my-3">
                  <OtpInput
                    length={4}
                    onOtpChange={(otpValue) => setOtp(otpValue)}
                  />
                </div>
              )}
              <button
                className="btn btn-primary w-100 large-button"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <RotatingLines
                    strokeColor="white"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="24"
                    visible={true}
                  />
                ) : passwordRequired ? (
                  "Login"
                ) : otpReceived ? (
                  "Verify OTP"
                ) : (
                  "Verify"
                )}
              </button>
            </form>

            {otpError && (
              <div
                style={{ color: "red", fontSize: "13px", marginTop: "10px" }}
              >
                {otpError}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

const OtpInput = ({ length = 4, onOtpChange }) => {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (index, event) => {
    const value = event.target.value;
    if (value === "" || /^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      onOtpChange(newOtp.join(""));

      if (value !== "" && index < length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData("text").replace(/\D/g, "");

    const newOtp = [...otp];
    for (let i = 0; i < length; i++) {
      if (pastedData[i]) {
        newOtp[i] = pastedData[i];
      }
    }
    setOtp(newOtp);
    onOtpChange(newOtp.join(""));

    const lastIndex = Math.min(pastedData.length, length) - 1;
    inputRefs.current[lastIndex]?.focus();
  };

  return (
    <div className="d-flex flex-row justify-content-evenly">
      {otp.map((digit, index) => (
        <Form.Control
          key={index}
          type="text"
          inputMode="numeric"
          maxLength="1"
          className="mx-1 text-center"
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          ref={(input) => (inputRefs.current[index] = input)}
          style={{
            width: "3rem",
            height: "3rem",
            fontSize: "1.5rem",
            textAlign: "center",
          }}
        />
      ))}
    </div>
  );
};
